import React from "react";
import { connect } from 'react-redux';
import lodash from 'lodash';
import MUIDataTable from "mui-datatables";
import i18n from 'i18n';

import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import MTablestyles from "assets/jss/material-dashboard-pro-react/customMTableStyle.jsx";

import CustomSweetAlert from "components/SweetAlert/CustomSweetAlert.jsx";
import Badge from "components/Badge/Badge.jsx";
import CustomToolbar from "components/CustomToolbar/CustomToolbar.jsx";
import TableActionButton from "components/CustomToolbar/TableActionButton.jsx"
import TableLoaderSpinner from 'components/Table/TableLoaderSpinner'
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import CloudDownload from "@material-ui/icons/CloudDownload";

import { swalConstants, earnSpecialsConstants, surveyConstants } from '../../constants';
//import { earnSpecialsAction } from "../../actions/earnspecials.actions";
import { surveyAction } from "../../actions/survey.actions";
// import { earnrulesServices } from "services";

import { plugins, crmValidator , loader, alert as customAlert } from "helpers";

//import EarnSpecialsForm from "./EarnSpecialsForm.jsx";
import CreateSurveyForm from "./CreateSurveyForm.jsx";
import TableSubSurveyList from "./TableSubSurveyList.jsx";

const style = {
   customCardContentClass: {
      paddingLeft: "0",
      paddingRight: "0"
   },
   cardIconTitle: {
      ...cardTitle,
      marginTop: "15px",
      marginBottom: "0px"
   },
   actionDiv: {
      display: "inline-flex"
   },
   textCapital: {
      textTransform: "capitalize"
   }
};

const pageStyle = { ...style, ...sweetAlertStyle };

const THEME = createMuiTheme(MTablestyles);
const moduleName = "earn_rule";

const renderBadgeStatus = (status) => {
   let BadgeColor
   switch (status) {
      case "Active": BadgeColor = "success"; break;
      case "Expired": BadgeColor = "danger"; break;
      default: BadgeColor = "gray";
   }
   return (<Badge color={BadgeColor}>{status}</Badge>)
}

class TableSurveyList extends React.Component {
   constructor(props) {
      super(props);

      this.state = {
         readOnly: true,
         page: 0,
         rowsPerPage: 10,
         count: 1,
         data: [],
         reqParams: "",
         showSurveyForm: false,
         showTable: true,
         surveyId: "",
      };

      this.onSearchChange = lodash.debounce(this.getSurveyData, 500)
   }

   handleCloseSurveyForm = () => {
      this.setState({ showSurveyForm: false, showTable: true });
   }

   openAddSurvey = () => {
      const { dispatch } = this.props;
      
      dispatch({ type: surveyConstants.OPEN_ADD_NEW_SURVEY })
      this.setState({ surveyId: "" });
      this.setState({ showSurveyForm: true, showTable: false });
   }

   

   openEditSurvey = (rowIndex) => {
      const { dispatch } = this.props;
      const rowData = this.getRowData(rowIndex)
      dispatch(surveyAction.getSurveyById(rowData._id))
      this.setState({ surveyId: rowData._id });
      this.setState({ showSurveyForm: true, showTable: false });
   }

   getSurveyData = (skip, limit, sortBy, sortDir, keyword) => {
      const { dispatch, tableReload } = this.props;
      let reqParams = "";
      if (!tableReload) {
         if (crmValidator.isEmptyValue(skip)) {
            skip = 0
         }
         if (crmValidator.isEmptyValue(limit)) {
            limit = 10
         }
         this.setState({
            page: skip,
            rowsPerPage: limit
         })
         skip = parseInt(limit) * parseInt(skip)

         reqParams += 'skip=' + skip
         reqParams += '&limit=' + limit

         if (!crmValidator.isEmptyValue(sortBy)) {
            reqParams += '&sortBy=' + sortBy
         }

         if (!crmValidator.isEmptyValue(sortDir)) {
            reqParams += '&sortDir=' + sortDir
         }

         if (!crmValidator.isEmptyValue(keyword)) {
            reqParams += '&keyword=' + keyword
         }

      } else {
         reqParams = this.state.reqParams
      }

      //dispatch(earnSpecialsAction.getEarnSpecialLists(reqParams))
      dispatch(surveyAction.getSurveyLists(reqParams))
      

      this.setState({
         reqParams: reqParams
      });

   }

   componentDidUpdate(prevProps) {
      const { tableReload, tableReset, dispatch } = this.props;
      if (tableReload || tableReset) {
         dispatch({ type: surveyConstants.TABLE_RELOAD_SUCCESS })
         this.getSurveyData();
      }
      if (prevProps.formInitialValue._idSurvey !== this.props.formInitialValue._idSurvey) {

         this.setState({ surveyId: this.props.formInitialValue._idSurvey });

      }
   }

   componentWillMount() {
      const { dispatch } = this.props;
      dispatch({ type: earnSpecialsConstants.CLEAR_PAGE_STATE, data: {} });
      this.getSurveyData()
   }

   getRowData(rowIndex = 0) {
      const { tableData } = this.props;
      //const data = tableData.earnSpecials;
      const data = tableData.survey;
      return data[rowIndex];
   }

   render() {
      const { classes, dispatch, tableData, formInitialValue, tableKey, tableLoader } = this.props;
      const { rowsPerPage, page, showSurveyForm, showTable } = this.state;

      //console.log("tableData : ",tableData);
      //console.log("TableSurvey render  formInitialValue : ",formInitialValue)

      // Get the current date
      const currentDate = new Date();

      // Check if startDate exists in the form and compare it to the current date
      const startDate = formInitialValue?.startDate ? new Date(formInitialValue.startDate) : null;
      const readOnlySurvey = (startDate && startDate < currentDate) ? true : false;

      let columns = [    
         {
            name: "surveyId",
            label: "Survey ID", 
            options: {
               customBodyRender: (value, tableMeta) => {
                  const rowIndex = tableMeta.rowIndex;
                  const rowData = this.getRowData(rowIndex);
                  if (lodash.has(rowData, 'surveyId')) {
                     return rowData.surveyId;
                  } else {
                     return ""
                  }
               }
            }          
         },    
         {
            name: "name",
            label: "Survey Topic", 
            options: {
               customBodyRender: (value, tableMeta) => {
                  const rowIndex = tableMeta.rowIndex;
                  const rowData = this.getRowData(rowIndex);
                  if (lodash.has(rowData, 'name')) {
                     return rowData.name;
                  } else {
                     return ""
                  }
               }
            }          
         },
         {
            name: "createDate",
            label: "Created Date",
            options: {
               customBodyRender: (value, tableMeta) => {
                  try {
                     const rowIndex = tableMeta.rowIndex;
                     const rowData = this.getRowData(rowIndex);
                     const date = new Date(rowData.created_at);
                     const day = String(date.getDate()).padStart(2, '0');
                     const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
                     const year = date.getFullYear();

                     let created_at = `${day}/${month}/${year}`;

                     return (<>{created_at} </>)
                  } catch (e) {
                     return ""
                  }
               }
            }
         },
         {
            name: "startDate",
            label: "Survey Period",
            options: {
               customBodyRender: (value, tableMeta) => {
                  try {
                     const rowIndex = tableMeta.rowIndex;
                     const rowData = this.getRowData(rowIndex);
                     
                     let date = new Date(rowData.startDate);
                     let day = String(date.getDate()).padStart(2, '0');
                     let month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
                     let year = date.getFullYear();

                     let startDate = `${day}/${month}/${year}`;

                     date = new Date(rowData.endDate);
                     day = String(date.getDate()).padStart(2, '0');
                     month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
                     year = date.getFullYear();

                     let endDate = `${day}/${month}/${year}`;

                     return (<>{startDate} - {endDate}</>)
                  } catch (e) {
                     return ""
                  }
               }
            }
         },
         {
            name: "status_survey",
            label: "Status",
            options: {
               customBodyRender: (value, tableMeta) => {
                  try {
                     const rowIndex = tableMeta.rowIndex;
                     const rowData = this.getRowData(rowIndex);
                     //let created_at = plugins.datetimeFormat(rowData.created_at, "date");

                     return (<>{rowData.status_survey} </>)
                  } catch (e) {
                     return ""
                  }
               }
            }
         },
      ]

      if (plugins.isHasPermission(moduleName, 'read')) {
         columns.push(
            {
               label: "Action",
               options: {
                  filter: false,
                  sort: false,
                  customBodyRender: (value, tableMeta) => {
                     return (
                        <div className={classes.actionDiv}>
                           {plugins.isHasPermission(moduleName, 'update') &&
                              <TableActionButton
                                 actionType="edit"
                                 onClick={(e) => {
                                    this.openEditSurvey(tableMeta.rowIndex)
                                 }}
                              />
                           }                          
                        </div>
                     )
                  }
               }
            }
         )
      }

      let options = {
         serverSide: true,
         count: tableData.total,
         page: page,
         rowsPerPage: rowsPerPage,
         print: false,
         customToolbar: () => {

            return (
               <>
                  
                  {plugins.isHasPermission(moduleName, 'create') &&(
                     <CustomToolbar handleClick={this.openAddSurvey.bind(this)} title="Add New" />
                  )}
               </>
            );
         },

         download: false,
         filter: false,
         selectableRows: "none",
         responsive: "scroll",
         rowsPerPageOptions: [5, 10, 20],
         onTableChange: (action, tableState) => {
            let skip, limit, sortBy, sortDir, keyword = ""

            if (tableState.page !== null) {
               skip = tableState.page
            }

            if (tableState.rowsPerPage !== null) {
               limit = tableState.rowsPerPage
            }

            if (tableState.activeColumn !== null) {
               sortBy = tableState.columns[tableState.activeColumn].name
            }
            if (tableState.announceText !== null) {
               sortDir = tableState.announceText.search("descending") !== -1 ? "desc" : "asc"
            }
            if (tableState.searchText !== null) {
               keyword = tableState.searchText
            }
            let actionList = ['changePage', 'sort', 'search', 'changeRowsPerPage']

            if (actionList.indexOf(action) !== -1) {
               if (action === "search") {
                  this.onSearchChange(skip, limit, sortBy, sortDir, keyword)
               } else {
                  this.getSurveyData(skip, limit, sortBy, sortDir, keyword)
               }
            }
         },
      }

      if (plugins.isHasPermission(moduleName, 'create')) {
         options.customToolbar = () => {
            return (
               <CustomToolbar handleClick={this.openAddSurvey.bind(this)} title="Add New" />
            );
         }
      }

      return (
         <div id="tableSurveyList">
            <CustomSweetAlert />
            
            {showSurveyForm && ( // Conditionally render the CreateSurveyForm
               <CreateSurveyForm
                  initialValues={formInitialValue}
                  initialId={formInitialValue._idSurvey} // for Edit mode
                  readOnly={!plugins.isHasPermission(moduleName, 'update')}
                  readOnlySurvey={readOnlySurvey}
                  onClose={this.handleCloseSurveyForm}
                  onSubmitSuccess={() => {
                     if (!formInitialValue || !formInitialValue._idSurvey) {
                       //this.setState({ showSurveyForm: false, showTable: true });
                     }
                  }}
               />
            )}
            {showSurveyForm && formInitialValue._idSurvey && ( // Conditionally render the CreateSurveyForm
               <TableSubSurveyList
                  initialValues={formInitialValue}
                  readOnly={!plugins.isHasPermission(moduleName, 'update')}
                  readOnlySurvey={readOnlySurvey}
                  onClose={this.handleCloseSurveyForm}
                  surveyId={this.state.surveyId} 
               />
            )}
           
            {showTable && ( // Conditionally render the MUIDataTable and TableLoaderSpinner
               <MuiThemeProvider theme={THEME}>
                  <MUIDataTable
                     key={tableKey}
                     title={"Create Survey"}
                     data={tableData.survey}
                     columns={columns}
                     options={options}
                  />
                  {tableLoader && <TableLoaderSpinner />}
               </MuiThemeProvider>
            )}
            
         </div>
      )
   }
}

function mapStateToProps(state) {
   const { tableReload, tableReset, tableData, formInitialValue, tableKey, tableLoader } = state.survey;
   const { package_features } = state.authentication;
   return {
      tableReload, tableReset, tableData, formInitialValue, tableKey, tableLoader, package_features
   };
}

export default connect(mapStateToProps)(withStyles(pageStyle)(TableSurveyList));
